module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    title: 'Product Carousel',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
  },
  table: {
    title: {
      index: 'NO',
      show: 'Active',
      title: 'TITLE',
      link: 'DEEP LINK TYPE',
      partner: 'PARTNER',
      status: 'STATUS',
      action: 'ACTION',
      country: 'COUNTRY',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      inactive: 'InActive',
      active: 'Active',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this Product Carousel?',
      edit: 'Are you sure to edit this Product Carousel?',
      enable: 'Are you sure you want to enable this Product Carousel?',
      disable: 'Are you sure you want to disable this Product Carousel?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
  form: {
    image3x4: 'Please upload a 4x3 image',
    imageUpload: '*Upload an image',
    title: 'Title',
    subTitle: 'Subtitle',
    link: 'Link',
    linkType: 'Page Type',
    countries: 'Countries',
    btnUpdateMoreForYou: 'Update',
    btnCreateMoreForYou: 'Add',
    updateMoreForYou: 'Edit Product Carousel',
    createMoreForYou: 'Add Product Carousel',
    backgroundColor: 'Background Color',
    titleColor: 'Title Color',
    subColor: 'Subtitle Color',
    cta: 'CTA',
    ctaTextColor: 'CTA Text Color',
    ctaBackgroundColor: 'CTA Background Color',
  },
  validate: {
    titleBlank: 'Please input title!',
    countryBlank: 'Please select country!',
    linkBlank: 'Please input a link!',
    linkTypeBlank: 'Please select page type!',
    imageBlank: 'Please input an image!',
    ctaBlank: 'Please input a CTA!',
    buttonList: 'Please input Button (All Product Carousel) text!',
    buttonDetail: 'Please input Button (Product Carousel Details) text!',
  },
  message: {
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      requireUpload: 'Please upload an image',
    },
    success: {
      updateMoreForYou: 'Product Carousel successfully updated.',
      createMoreForYou: 'Product Carousel successfully added.',
      deleteMoreForYou: 'Product Carousel successfully deleted.',
    },
  },
};
